export const daysLeft = (isoDate) => {
  if (!isoDate) return null;
  const end = new Date(`${isoDate}T23:59:59`);
  if (Number.isNaN(end.getTime())) return null;
  return Math.ceil((end.getTime() - Date.now()) / 86400000);
};

export const countdownFor = (status, closesDate, closesAt) => {
  const closed = status !== "open";
  const d = daysLeft(closesDate);
  if (closed || (d != null && d < 0)) return { text: "Closed", urgent: false };
  if (d == null) return { text: closesAt ? `Closes ${closesAt}` : "Open", urgent: false };
  if (d === 0) return { text: "Closes today", urgent: true };
  if (d === 1) return { text: "Closes tomorrow", urgent: true };
  return { text: `Closes in ${d} days`, urgent: d <= 3 };
};

export const demandFor = (status, capacity, minimumUsd, interestCount) => {
  if (status !== "open" || !capacity || capacity <= 0) return null;
  const indicative = (interestCount || 0) * (minimumUsd || 0);
  return { pct: Math.min(100, Math.round((indicative / capacity) * 100)) };
};
